import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { hasPermission } from "../../../shared/utils/permissions";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/c/$customerSlug/bikes")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: ({ context }) => {
    if (!hasPermission(context.auth.user, "admin.bikes.read")) {
      throw redirect({ to: "/app" });
    }
  },
  component: () => <Outlet />,
});
